/**
 * Newsletter subscription form schema
 */

import { z } from 'zod';
import { emailSchema, optionalCheckboxSchema } from '../base-fields';

/**
 * Newsletter subscription schema
 */
export const newsletterSubscriptionSchema = z.object({
    email: emailSchema,
    marketingEmails: optionalCheckboxSchema,
    profiling: optionalCheckboxSchema,
    thirdParty: optionalCheckboxSchema
});

// Type inference
export type NewsletterSubscriptionFormData = z.infer<typeof newsletterSubscriptionSchema>;
